module.exports = __webpack_public_path__ + "img/filter.be610ca9.svg";